<template>
  <v-row no-gutters>
    <div class="descriptive-text">
      <span v-if="aqi !== $t('map.popover.valueBlank')"> {{ aqiRange }}: </span>
      {{ aqiMessage }}
    </div>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { aqiTypeKeys } from '@/store/map/utils'
import { getAQICode } from '@/services/map'

export default defineComponent({
  name: 'aqiDescription',
  props: {
    aqi: {
      type: [Number, String] as PropType<number | string | null>,
      default: null
    },
    aqiType: {
      type: Number,
      default: 0
    },
    measurementType: {
      type: Number,
      default: 0
    }
  },
  computed: {
    numericAqi(): number {
      return typeof this.aqi === 'number' ? this.aqi : Number.NaN
    },
    aqiRange(): string {
      const code = getAQICode(this.numericAqi, this.aqiType, this.measurementType)
      if (code === 'error') {
        return String(this.$t('map.popover.descriptions.aqi_error.range'))
      }
      if (code === 'none') {
        return String(this.$t('map.popover.descriptions.aqi_none.range'))
      }
      return `${code.min}–${code.max}`
    },
    aqiMessage(): string {
      const code = getAQICode(this.numericAqi, this.aqiType, this.measurementType)
      if (code === 'error') {
        return String(this.$t('map.popover.descriptions.aqi_error.message'))
      }
      if (code === 'none') {
        return String(this.$t('map.popover.descriptions.aqi_none.message'))
      }
      const key = (aqiTypeKeys as Record<number, string>)[this.aqiType] ?? 'us'
      return String(this.$t(`map.popover.descriptions.${key}.aqi_${code.level}.message`))
    }
  }
})
</script>

<style lang="scss" scoped>
.descriptive-text {
  padding: 8px;
  font-weight: 300;
  font-size: 12px;
  line-height: 12px;
  min-height: 32px;
}

.widget-xxs,
.widget-xs,
.widget-sm {
  .descriptive-text {
    font-size: 12px;
    line-height: 12px;
  }
}
</style>
